import { SprintProductStatus, useListPmSprintProducts, useSprintProductsForViewer } from '@data';

import { useProductViewer } from './productViewer';

const SETTLED = [SprintProductStatus.closed, SprintProductStatus.approved, SprintProductStatus.invoiced];

export interface SettledSprints {
  closedSprintIds: string[];
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

/** The product's settled sprints, from our list or the client's: a client is refused ours, and theirs counts what was sent. */
export const useSettledSprints = (organizationId: string | undefined, productId: string): SettledSprints => {
  const { isClient } = useProductViewer();
  // No row exists until someone opens or closes it, so anything not listed is still open; wholeHistory lifts the backlog cutoff.
  const ours = useListPmSprintProducts(isClient ? undefined : organizationId, {
    statuses: SETTLED,
    wholeHistory: true,
    productId,
  });
  const theirs = useSprintProductsForViewer(false, isClient ? organizationId : undefined, {
    statuses: SETTLED,
    productId,
  });
  const source = isClient ? theirs : ours;

  return {
    // A client's list is filtered here: the API answers them with every product they read, whatever productId said.
    closedSprintIds: (source.data?.items ?? [])
      .filter(item => !isClient || (item.product?.id ?? item.productId) === productId)
      .map(item => item.sprintId ?? item.sprint?.id)
      .filter((id): id is string => !!id),
    isLoading: source.isLoading,
    isError: source.isError,
    refetch: () => {
      source.refetch();
    },
  };
};
